import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'hyphenate'
})
export class HyphenatePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\s+/g, '-').toLowerCase();
  }
}
